import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ApprovalWorkflowDialogWrapper } from "./ApprovalWorkflowDialogStyled";
import { useEffect } from "react";
import { Content } from "./Content";
const ApprovalWorkflowDialog = ({
  optionalApproval,
  show,
  title,
  heading,
  popupType,
  imgsrc,
  showError,
  textboxError,
  approverUsers,
  selectedApprovers,
  setSelectedApprovers,
  dialogText,
  handleTextBoxChange,
  handleConfirmClick,
  handleCancelClick,
  dialogApproverRoles,
  isOptionalApprover,
}) => {
  const inputRef = useRef(null);
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });
  console.log("popupType", popupType);

  const roleLabels = {
    2: "Pricing Team",
    3: "SAM Leadership",
    4: "Pricing Manager",
    5: "Pricing VP",
    6: "SAM Leadership Level 3",
  };
  console.log("approverUsers", approverUsers);
  const usersByRole = dialogApproverRoles?.reduce((acc, roleId) => {
    acc[roleId] = approverUsers.filter((user) => user.roleId === roleId);

    return acc;
  }, {});

  const [submitError, setubSubmitError] = useState(
    popupType === 1 ? textboxError : "",
  );

  useEffect(() => {
    setubSubmitError(textboxError);
  }, [textboxError]);

  useEffect(() => {
    if (show && popupType === Content.APPROVE) {
      setSelectedApprovers({});
      handleTextBoxChange("");
      setubSubmitError("");
    }
  }, [show]);

  const handleChange = (e) => {
    let value = e?.target?.value;
    if (typeof value === "undefined " || !value || value?.trim() === "") {
      setubSubmitError("This field is required.");
    } else {
      setubSubmitError("");
    }
    handleTextBoxChange(value);
  };

  const handleSubmit = () => {
    const hasMissingRequiredApprover = dialogApproverRoles?.some((roleId) => {
      const userId = selectedApprovers?.[roleId]?.userId;

      return typeof userId === "undefined" || userId === null || `${userId}`.trim() === "";
    });

    if (
      !isOptionalApprover &&
      popupType === Content.APPROVE &&
      hasMissingRequiredApprover
    ) {
      setubSubmitError("Please select all required approvers");

      return;
    }

    if (!dialogText || dialogText.trim() === "") {
      setubSubmitError("Please add a comment.");

      return;
    }

    setubSubmitError("");

    handleConfirmClick();
  };

  return (
    <div>
      <ApprovalWorkflowDialogWrapper
        open={show}
        onClose={handleCancelClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="customDialog"
          >
            <div>
              <img src={imgsrc} alt="img" />
            </div>
            <div className={popupType === Content.NOTE ? "note" : ""}>
              {heading}
            </div>
            {popupType === Content.APPROVE && (
              <div>
                <div className="inputform">
                  <TextField
                    className="formValue"
                    value={dialogText || ""}
                    onChange={handleChange}
                    placeholder="Any comments? Please type here."
                    multiline
                    rows={4}
                    name="note"
                  />
                  <Box className="errorBox">
                    {submitError && (
                      <span className="error">{submitError}</span>
                    )}
                  </Box>
                </div>
                <div>
                  {dialogApproverRoles.map((roleId) => (
                    <FormControl
                      key={roleId}
                      className="customDropdown"
                      fullWidth
                      sx={{ marginBottom: 2 }}
                    >
                      <Select
                        value={selectedApprovers[roleId]?.userId || ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;

                          if (submitError && `${selectedValue}`.trim() !== "") {
                            setubSubmitError("");
                          }

                          setSelectedApprovers((prev) => ({
                            ...prev,

                            [roleId]: {
                              roleId,

                              userId: selectedValue,
                            },
                          }));
                        }}
                        displayEmpty
                      >
                        <MenuItem value="">
                          Select {roleLabels[roleId]}{isOptionalApprover ? " (Optional)" : ""}
                        </MenuItem>

                        {usersByRole[roleId]?.map((user) => (
                          <MenuItem key={user.userId} value={user.userId}>
                            {user.firstName} {user.lastName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ))}
                  <Box className="errorBox">
                    {showError && <span className="error">{showError}</span>}
                  </Box>
                </div>
              </div>
            )}
            {popupType === Content.NOTE && (
              <div>
                <div className="inputform">
                  <TextField
                    className="formValue"
                    error={!!submitError}
                    onChange={handleChange}
                    helperText={submitError}
                    placeholder="Type here."
                    multiline
                    rows={4}
                    name="note"
                  />
                </div>
              </div>
            )}
            {popupType === Content.REJECT && (
              <div>
                <div className="inputform">
                  <TextField
                    inputRef={inputRef}
                    className="formValue"
                    onChange={handleChange}
                    placeholder="Type here."
                    multiline
                    rows={4}
                    name="note"
                  />
                </div>
                <Box>
                  {submitError !== "" && (
                    <span className="error">{submitError}</span>
                  )}
                </Box>
              </div>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialogbutton">
          {popupType === Content.CONFIRM && (
            <Button
              variant="contained"
              className="confirmButton"
              onClick={handleConfirmClick}
            >
              OK
            </Button>
          )}
          {popupType !== Content.CONFIRM && (
            <>
              <Button
                variant="outlined"
                className="rightButton"
                onClick={handleCancelClick}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="confirmButton"
                onClick={handleSubmit}
              >
                Confirm
              </Button>
            </>
          )}
        </DialogActions>
      </ApprovalWorkflowDialogWrapper>
    </div>
  );
};

export default ApprovalWorkflowDialog;
